/**
 * Router paths configuration
 *
 * Centralized definition of all application routes.
 */

export const routerPaths = {
    home: "/home",
    upload: {
        finJournals: "/upload/fin-journals-standalone",
        tbgl: "/upload/tb-gl",
    },
    files: {
        // The all-files and TB/GL lists are superseded by the Homepage v2
        // board, but stay until the board is enabled everywhere (the
        // `homepage_v2_enabled` company flag) — with the flag off these are
        // still the landing pages.
        list: "/files",
        tbgl: "/files/tb-gl",
        finJournals: "/files/fin-journals",
        archive: "/files/archive",
        detail: (fileId: string) => `/files/${fileId}`,
    },
    settings: {
        books: "/settings/books",
        chartOfAccounts: "/settings/chart-of-accounts",
        propcodes: "/settings/propcodes",
        segments: "/settings/segments",
        yardiImport: "/settings/yardi-import",
    },
    // Support
    support: {
        list: "/support",
        detail: (ticketId: string) => `/support/${ticketId}`,
    },
    // Admin routes
    admin: {
        auditLog: "/admin/audit-log",
        submissions: "/admin/submissions",
        globalAuditLog: "/admin/global-audit-log",
        companies: "/admin/companies",
        supportForwarded: "/admin/support-forwarded",
        users: "/admin/users",
        businessPartners: "/admin/business-partners",
        businessPartnerDetails: (bpId: string) => `/admin/business-partners/${bpId}/details`,
        businessPartnerDeals: (bpId: string) => `/admin/business-partners/${bpId}/deals`,
        businessPartnerDealCreate: (bpId: string) => `/admin/business-partners/${bpId}/deals/new`,
        businessPartnerDealDetail: (bpId: string, dealId: string) =>
            `/admin/business-partners/${bpId}/deals/${dealId}`,
        portfolioCompanies: "/admin/portfolio-companies",
        portfolioCompanyDealCreate: (pcId: string) =>
            `/admin/portfolio-companies/${pcId}/deals/new`,
        announcements: "/admin/announcements",
        emailCommunications: "/admin/email-communications",
    },
} as const;
